import { Component, OnInit, Injector, AfterContentChecked } from '@angular/core';
import { TableAbstractComponent } from '../../../common-page-components/classes/table-abstract-component';
import { ContinentalRankingFiltersService } from '../../services/continental-ranking-filters.service';
import { ContinentalRankingStore } from '../../../common-page-components/stores/entities-store/continental-ranking.store';
import { HttpClient } from '@angular/common/http';
import { combineLatest, first, map, mergeMap, tap } from 'rxjs/operators';
import { animationsTable } from 'src/app/common-page-components/wa-table/wa-table.component';
import { of } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';
@Component({
  selector: 'app-bootstrap-continental-ranking',
  templateUrl: './bootstrap-continental-ranking.component.html',
  styleUrls: ['./bootstrap-continental-ranking.component.scss'],
  animations: animationsTable,
})
export class BootstrapContinentalRankingComponent extends TableAbstractComponent implements OnInit, AfterContentChecked {
  /**
   * The headers function for check if the table must be adapted to team.
   *
   * @param {boolean} isTeam the is team flag.
   * @returns
   * @memberof BootstrapContinentalRankingComponent
   */
  headers(isTeam: boolean) {
    let headers;
    if (isTeam) {
      headers = [
        { name: 'Ranking', isSortable: true, sortProperty: 'RANKING' },
        { name: 'Team', isSortable: true, sortProperty: 'TEAM' },
        { name: 'Points', isSortable: true, sortProperty: 'Points' },
        { name: '', isSortable: false }
      ];
    } else {
      headers = [
        { name: 'Ranking', isSortable: true, sortProperty: 'RANKING' },
        { name: 'Name', isSortable: true, sortProperty: 'NAME' },
        { name: 'Country', isSortable: true, sortProperty: 'TEAM' },
        { name: "Points", isSortable: true, sortProperty: 'Points' },
        { name: '', isSortable: false }
      ];
    }
    return headers;
  }

  translationService:TranslocoService;


  /**
   * The header name to be set.
   *
   * @memberof BootstrapContinentalRankingComponent
   */
  headerName = '';
  constructor(injector: Injector, public continental_filters_service: ContinentalRankingFiltersService) {
    super(injector, continental_filters_service, new ContinentalRankingStore(injector.get(HttpClient), injector));
    this.translationService = injector.get(TranslocoService);
  }

  /**
   * Getter for check if the continent is empty.
   *
   * @readonly
   * @memberof BootstrapContinentalRankingComponent
   */
  get isContinentEmpty() {
    return this.continental_filters_service.regionCombo ? this.continental_filters_service.regionCombo.comboData.pipe(
      map(a => a.CaId == undefined),
    ) : of(false)
  }

  /**
   * {@inheritdoc}
   *
   * @memberof BootstrapContinentalRankingComponent
   */
  ngOnInit() {
    this.subscriptions.push((this.filter_service as ContinentalRankingFiltersService).getDataStreamWithFilters()
      .pipe(
        combineLatest([this.reload.asObservable()]),

        map(([a, b]) => a),
        map(([order, text, category, region, date, discipline, country, individualTeam]) => {
          if (!region.CaId) {
            this.ShowNoResultsBox = true;
            this.headerName = '';
          } else {
            this.ShowNoResultsBox = false;
            if (category['Name'].includes('Team') && individualTeam.Name === 'Team') {
              this.headerName = `${category['Name']}`;
            } else {
              this.headerName = `${category['Name']} ${this.translationService.translate(individualTeam.Name)}`;
            }
          }
          const params = {
            Continent: region.CaId,
            fText: text.text,
            SortBy: order.sortingSend,
            CatCode: category['Code'],
            Country: country['NOC'],
            Detailed: 1,
            Team: individualTeam.Value === true ? 1 : undefined,
            Date: date.value
              ? String(
                new Date(
                  date.value.value.getTime() -
                  date.value.value.getTimezoneOffset() * 60000
                )
                  .toISOString()
                  .slice(0, 10)
              )
              : undefined,
          };
          return params;
        }),
        mergeMap(params => this.model.requestData(params, this.request_more_data))
      )
      .subscribe(next => {
      }));
  }

  /**
   * {@inheritdoc}
   *
   * @memberof BootstrapContinentalRankingComponent
   */
  ngAfterContentChecked(): void {
    // This is a workaround for change the style in combo when no data is selected.
    const defaultColor = '#4A4A4A';
    const selectNode = document.evaluate("//lib-combo[@id='regionmembercombo']//span/label", document).iterateNext();
    if (selectNode) {
      if ((selectNode as any).innerText == 'Select') {
        (selectNode as any).style.color = 'lightgrey';
      } else {
        (selectNode as any).style.color = defaultColor;
      }
    }
  }


  /**
   * A method for select the continent and set active.
   *
   * @param {*} continent The continent to be selected
   * @param {boolean} shouldDeselect If the continent should be deselected.
   * @memberof BootstrapContinentalRankingComponent
   */
   selectContinent(continent, shouldDeselect = false) {
    this.continental_filters_service.regionCombo.comboData.pipe(
      first(),
      tap(a => {
        let continentSelected = continent;
        if (shouldDeselect === true && a.Continent === continent.Continent) {
          continentSelected = { Continent: 'Select' };
        }
        this.continental_filters_service.regionCombo.filterInfo.options.options_selected_subject.next(continentSelected);
      })
    ).subscribe();
  }

  /**
   * Get continent names
   *
   * @readonly
   * @memberof BootstrapContinentalRankingComponent
   */
     get continentNames() {
      return this.continental_filters_service.regionCombo
        .filterInfo.options.options_subject.asObservable()
        .pipe(map(a => a.filter(value => value.Continent !== 'Select').map(a => a)))
    }


  /**
   * Get continent assets for active and not active region
   *
   * @param {string} continent
   * @returns
   * @memberof BootstrapContinentalRankingComponent
   */
   getContinentAsset(continent: string) {
    return this.continental_filters_service.regionCombo.comboData.pipe(
      map(
        a => {
          return a.Continent === continent ?
            '../../../../../../modules/custom/wa_angular/app/assets/images/assets-maps/' + continent.toLowerCase().toString() + '-active.png'
            : '../../../../../../modules/custom/wa_angular/app/assets/images/assets-maps/' + continent.toLowerCase().toString() + '.png'

        }))
  }


}
